import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

const LotSkeleton = ({ count = 2 }) => {
  return (
    <Stack spacing={2} mt="50px" mb="20px">
      <Stack direction="row" alignItems="center" gap={2}>
        <Skeleton variant="text" width={80} height={50} />
        <Skeleton variant="text" width={150} height={60} />
        <Skeleton variant="text" width={150} height={40} sx={{ ml: 'auto' }} />
        <Skeleton variant="text" width={80} height={30} />
      </Stack>
      {Array.from({ length: count }).map((_, i) => (
        <Card key={i} sx={{ backgroundColor: 'white' }}>
          <CardContent>
            <Grid
              container
              justifyContent="space-between"
              alignItems="flex-start"
            >
              {/* Left Section */}
              <Grid size={{ xs: 12, md: 8 }}>
                <Stack spacing={1}>
                  <Skeleton variant="text" width="70%" height={30} />
                  <Skeleton variant="text" width="50%" height={24} />
                  <Box
                    display="flex"
                    gap={1}
                    flexWrap="wrap"
                    mt="20px !important"
                  >
                    <Skeleton variant="rounded" width={120} height={24} />
                    <Skeleton variant="rounded" width={180} height={24} />
                  </Box>
                </Stack>
              </Grid>

              {/* Right Section */}
              <Grid size={{ xs: 12, md: 4 }} textAlign="right">
                <Stack spacing={1} alignItems="flex-end">
                  <Skeleton variant="text" width="80%" height={24} />
                  <Skeleton variant="text" width="40%" height={20} />
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
};

export default LotSkeleton;
